/* eslint-disable import/prefer-default-export */
import axios from 'axios';

const ApiPrec = axios.create({ baseURL: 'https://apiprec.inmet.gov.br' });

export default ApiPrec;
